import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { DEFAULT_COUNTRY } from '@invitae/nucleobase-engine-contentful';
import { mergeScriptsById } from '../utils/mergeScriptsById.esm.js';
import AppProvider from './AppProvider/AppProvider.esm.js';
import { Header } from './Header/Header.esm.js';
import baseThirdPartyScripts from './ThirdPartyScripts/baseThirdPartyScripts.esm.js';
import ThirdPartyScripts from './ThirdPartyScripts/ThirdPartyScripts.esm.js';

var NucleobaseShell = function (_a) {
    var _b, _c;
    var thirdPartyScripts = _a.thirdPartyScripts, headerConfig = _a.headerConfig, Head = _a.Head, _d = _a.metadata, metadata = _d === void 0 ? undefined : _d, props = __rest(_a, ["thirdPartyScripts", "headerConfig", "Head", "metadata"]);
    var mergedThirdPartyScripts = mergeScriptsById(baseThirdPartyScripts, thirdPartyScripts);
    var includeThirdPartyScripts = Head !== 'head' && (mergedThirdPartyScripts === null || mergedThirdPartyScripts === void 0 ? void 0 : mergedThirdPartyScripts.length) > 0;
    var includeHeader = headerConfig && ((_b = props === null || props === void 0 ? void 0 : props.children) === null || _b === void 0 ? void 0 : _b.fields);
    // Contentful's children.metadata relates to contentful object itself, not HTML values
    // Contentful's HTML values are in children.fields hence the check through that object
    var contentfulMetadata = (_c = props === null || props === void 0 ? void 0 : props.children) === null || _c === void 0 ? void 0 : _c.fields;
    return (React__default.createElement(React__default.Fragment, null,
        includeHeader && (React__default.createElement(Header, __assign({}, headerConfig, { Head: Head, countryCode: props.countryCode || DEFAULT_COUNTRY, isCSR: Head === 'head', metadata: contentfulMetadata || metadata }))),
        React__default.createElement(AppProvider, __assign({}, props)),
        includeThirdPartyScripts && React__default.createElement(ThirdPartyScripts, { Head: Head, scripts: mergedThirdPartyScripts })));
};

export { NucleobaseShell as default };
//# sourceMappingURL=NucleobaseShell.esm.js.map
